import React from 'react';
import ReactDOM from 'react-dom';


//Passed properties
interface PageProps {
    pageTitle: string
}

//Internal state
interface PageState {
    titleEl: Element,
    siteTitle: string
}

//Sets the title of the page, so visually you can tell what page a tab is on
//We get the title property of the html page and then set the contents
export class Title extends React.Component<PageProps, PageState> {
    constructor(props: PageProps) {
        super(props);
        this.state = {
            titleEl: document.getElementsByTagName("title")[0],
            siteTitle: 'Musashi - V2.0'
        }
    }

    render() {
        let fullTitle;
        if(this.props.pageTitle) {
            fullTitle = this.state.siteTitle + " - " + this.props.pageTitle;
        } else {
            fullTitle = this.state.siteTitle;
        }
        
        return ReactDOM.createPortal(
            fullTitle || "",
            this.state.titleEl
        );
    }
}

export default Title;